import { ReactComponent as SaudiRiyalBlack } from "./Saudi_Riyal_Symbol-2.svg";
import { ReactComponent as SaudiRiyalWhite } from "./Saudi_Riyal_Symbol-2-white.svg";
import { ReactComponent as SaudiRiyalBlue } from "./Saudi_Riyal_Symbol-2-blue.svg";
import React from "react";

const currencyComponents = {
  white: SaudiRiyalWhite,
  black: SaudiRiyalBlack,
  blue: SaudiRiyalBlue,
};

const style = { width: 15, height: 15, marginRight: 5, marginBottom: 5 };

export const renderCurrency = (currency, color, text = "") => {
  try {
    if (currency === "SAR" || currency === "رس") {
      const CurrencyComponent = currencyComponents[color];
      if (CurrencyComponent) {
        return (
          <>
            {currency === "SAR" && <CurrencyComponent style={style} />}
            <span>{text}</span>
            {currency === "رس" && <CurrencyComponent style={style} />}
          </>
        );
      }
    }
  } catch (error) {
    console.error("Error in renderCurrency:", error);
  }
  return `${text} ${currency}`;
};

export const getCurrencyIcon = (settings) => {
  switch (settings?.currency_iso.toLowerCase()) {
    case "sar":
      return "icon-sar";
    case "aed":
      return "icon-aed";
    default:
      return "";
  }
};

export const getCurrencyIso = (settings,language) => {
  const iso = settings?.currency_iso;
  const isEnglish = language === "english";
  switch (iso) {
    case "SAR":
      return isEnglish ? "SAR" : "رس";
    case "AED":
      return isEnglish ? "AED" : "دإ";
    default:
      return isEnglish ? settings?.currency_english : settings?.currency_local;
  }
};